import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    template: `
        <div class="topbar">
            <ng-transclude></ng-transclude>
        </div>
        <style>
            .topbar:has(.middle-content) {
                justify-content: space-between;
            }
        </style>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/learnModal/topbar/index.js